/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StoreAmenityCollectionResponse } from '../../models/store-amenity-collection-response';

export interface GetStoreAmenities$Params {
  'Active-Tenant-Identifier': string;
  storeId: string;
  page?: number;
  size?: number;
}

export function getStoreAmenities(http: HttpClient, rootUrl: string, params: GetStoreAmenities$Params, context?: HttpContext): Observable<StrictHttpResponse<StoreAmenityCollectionResponse>> {
  const rb = new RequestBuilder(rootUrl, getStoreAmenities.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('storeId', params.storeId, {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StoreAmenityCollectionResponse>;
    })
  );
}

getStoreAmenities.PATH = '/stores/{storeId}/amenities';
